import React, { useEffect, useState } from "react";
import img from "../Images/d.jpg";

const Notifications = () => {
  const API = "https://api.rootnet.in/covid19-in/notifications";
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(API)
      .then((response) => response.json())
      .then((data) => setData(data.data.notifications));
  }, []);

  const renderTable = () => {
    return data.map((data) => {
      return (
        <tr>
          <td>
            <i class="fa fa-newspaper-o"></i>
          </td>
          <td>{data.title}</td>
          <td>
            <a href={data.link}>Visit here!</a>
          </td>
        </tr>
      );
    });
  };
  return (
    <div className="p-5">
      <h2 className="text-center">Covid Updates</h2>

      <img src="https://i.pinimg.com/564x/09/1a/ed/091aedf87a8417544af3d2be21cc2f1f.jpg" alt="hospital" className="mx-auto img-fluid  d-block" style={{height:"250px"}}/>
      <div class="table-responsive">
        <table id="dtBasicExample" className="table" width="100%">
          <thead>
            <tr>
              <th>
                <i class="fa fa-newspaper-o"></i>
              </th>
              <th>Title</th>
              <th>Link</th>
            </tr>
          </thead>
          <tbody>{renderTable()}</tbody>
        </table>
      </div>
    </div>
  );
};

export default Notifications;
